// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o3-0";
export var buttonContainer = "_o3-3";
export var cancelButton = "_o3-4";
export var headerSection = "_o3-6";
export var headerTitle = "_o3-9";
export var messageSideLeft = "_o3-1";
export var messageSideRight = "_o3-2";
export var orderNumberContainer = "_o3-7";
export var orderNumberLabel = "_o3-8";
export var submitButton = "_o3-5";